import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import BookingDto from '@/models/Bookings/BookingDto';
import BookingDateDto from '@/models/BookingDates/BookingDateDto';
import BookingRoleWorkerDto from '@/models/BookingRoleWorkers/BookingRoleWorkerDto';
import WorkerDto from '@/models/Workers/WorkerDto';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import BookingBrowseWorkersViewModel from '@/models/BookingRoleWorkers/BookingBrowseWorkersViewModel';
import BookingOfferedWorkersViewModel from '@/models/BookingRoleWorkers/BookingOfferedWorkersViewModel';
import WorkerProfileSearchRequest from '@/models/Workers/WorkerProfileSearchRequest';
import WorkerSearchViewModel from '@/models/Workers/WorkerSearchViewModel';
import SelectableEntity from '@/models/Shared/SelectableEntity';
import CreateBookingRoleWorkersRequest from '@/models/BookingRoleWorkers/CreateBookingRoleWorkersRequest';
import CreateBookingDateRequest from '@/models/BookingDates/CreateBookingDateRequest';
import BookingBookedWorkersViewModel from '@/models/BookingRoleWorkers/BookingBookedWorkersViewModel';
import TimesheetDto from '@/models/Timesheets/TimesheetDto';
import ShiftDto from '@/models/Shifts/ShiftDto';
import WorkerSearchOptionsResponse from '@/models/Workers/WorkerSearchOptionsResponse';
import DistanceViewModel from '@/models/Shared/DistanceViewModel';
import ConfirmAppliedBookingRoleWorkersRequest from '@/models/BookingRoleWorkers/ConfirmAppliedBookingRoleWorkerRequest';
import RejectAppliedBookingRoleWorkersRequest from '@/models/BookingRoleWorkers/RejectAppliedBookingRoleWorkerRequest';
import NewBookingOptionsDto from '@/models/Bookings/NewBookingOptionsDto';
import BookingRoleViewModel from '@/models/BookingRoles/BookingRoleViewModel';
import CreateBookingRoleRequest from '@/models/BookingRoles/CreateBookingRoleRequest';
import UpdateBookingRoleRequest from '@/models/BookingRoles/UpdateBookingRoleRequest';
import ShiftViewModel from '@/models/Shifts/ShiftViewModel';
import UpdateShiftRequest from '@/models/Shifts/UpdateShiftRequest';
import CreateShiftRequest from '@/models/Shifts/CreateShiftRequest';
import PositionDto from '@/models/Positions/PositionDto';
import TimesheetViewModel from '@/models/Timesheets/TimesheetViewModel';
import UpdateTimesheetRequest from '@/models/Timesheets/UpdateTimesheetRequest';
import DateTimeUtils from '@/lib/dateTimeUtils';
import ConfirmAppliedBookingRoleWorkerRequest from '@/models/BookingRoleWorkers/ConfirmAppliedBookingRoleWorkerRequest';
import BookAppliedBookingRoleWorkerRequest from '@/models/BookingRoleWorkers/BookAppliedBookingRoleWorkerRequest';
import QuickBookRequest from '@/models/BookingRoleWorkers/QuickBookRequest';
import NoteDto from '@/models/Notes/NoteDto';
import UpdateNoteRequest from '@/models/Notes/UpdateNoteRequest';
import CreateNoteRequest from '@/models/Notes/CreateNoteRequest';
import CreateBookingRoleWorkerShiftsRequest from '@/models/BookingRoleWorkerShifts/CreateBookingRoleWorkerShiftsRequest';
import CancelBookingRequest from '@/models/Bookings/CancelBookingRequest';
import CancelBookingRoleRequest from '@/models/BookingRoles/CancelBookingRoleRequest';
import CancelShiftRequest from '@/models/Shifts/CancelShiftRequest';
import CancelBookingRoleViewModel from '@/models/BookingRoles/CancelBookingRoleViewModel';
import CancelShiftViewModel from '@/models/Shifts/CancelShiftViewModel';
import CancelBookingRoleWorkerShiftRequest from '@/models/BookingRoleWorkerShifts/CancelBookingRoleWorkerShiftRequest';
import CancelBookingRoleWorkerViewModel from '@/models/BookingRoleWorkerShifts/CancelBookingRoleWorkerShiftViewModel';
import CancelBookingRoleWorkerShiftViewModel from '@/models/BookingRoleWorkerShifts/CancelBookingRoleWorkerShiftViewModel';
import BookingRoleWorkerShiftDto from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftDto';
import UpdateBookingGeneralDetailsRequest from '@/models/Bookings/UpdateBookingGeneralDetailsRequest';
import WorkerStatus from '@/models/Workers/WorkerStatus';
import WorkType from '@/models/Shared/WorkType';
import AvailabilityRestrictionCheckRequest from '@/models/AvailabilityRestrictions/AvailabilityRestrictionCheckRequest';
import AvailabilityRestrictionSummary from '@/models/AvailabilityRestrictions/AvailabilityRestrictionSummary';
import EditTimesheetOptionsResponse from '@/models/Timesheets/EditTimesheetOptionsResponse';
import JourneyCalculationType from '@/models/Timesheets/JourneyCalculationType';
import SkillDto from '@/models/Skills/SkillDto';
import QualificationDto from '@/models/Qualifications/QualificationDto';
import CalculatePayRateForBookRequest from '@/models/WorkerPositions/CalculatePayRateForBookRequest';
import CalculatePayRateForQuickBookRequest from '@/models/WorkerPositions/CalculatePayRateForQuickBookRequest';
import WorkerMinimumPayRateRequest from '@/models/Workers/WorkerMinimumPayRateRequest';
import CalculatePayRateResponse from '@/models/WorkerPositions/CalculatePayRateResponse';
import SearchMatchType from '@/models/Shared/SearchMatchType';
import NoteCategoryDto from '@/models/NoteCategories/NoteCategoryDto';
import CreateConversationRequest from '@/models/Conversations/CreateConversationRequest';
import MessageDto from '@/models/Messages/MessageDto';
import ConversationDto from '@/models/Conversations/ConversationDto';
import EntityType from '@/models/Shared/EntityType';
import { QueryFieldFilterConstraint, addDoc, collection, getDocs, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import db from '@/firebase/init';
import ConversationParticipantDto from '@/models/Conversations/ConversationParticipantDto';
import AssignConversationRequest from '@/models/Conversations/AssignConversationRequest';
import CreateConversationParticipantRequest from '@/models/Conversations/CreateConversationParticipantRequest';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import UpdateConversationStatusRequest from '@/models/Conversations/UpdateConversationStatusRequest';


export interface IBookingDetailsState {
  loading: boolean;
  loadingWorkers: boolean;
  loadingWorker: boolean;
  loadingNotes: boolean;
  loadingDialog: boolean;
  currentBooking: BookingDto | null;   
  selectedBookingRole: BookingRoleDto | null;
  offeredWorkersVM: BookingOfferedWorkersViewModel;
  browseWorkersVM: BookingBrowseWorkersViewModel;
  workerSearchViewModel: WorkerSearchViewModel;
  bookedWorkersVM: BookingBookedWorkersViewModel;
  editTimesheetOptions: EditTimesheetOptionsResponse;
  editTimesheetMinimumPayRate: number;
  model: WorkerProfileDto;
  newBookingOptions: NewBookingOptionsDto;
  notes: NoteDto[];
  noteCategories: NoteCategoryDto[];
  cancelSuccessful: boolean;
  loadingConversations: boolean;
  loadingConversation: boolean;
  conversations: ConversationDto[];
  conversation: ConversationDto | null;
  unsubscribeToConversations: any;
  messages: MessageDto[];
  unsubscribeToMessages: any;
  conversationParticipants: ConversationParticipantDto[];
  unsubscribeToConversationParticipants: any;
  agencyUsers: AgencyUserDto[];
}

@Module({ dynamic: true, store, name: 'BookingDetails', namespaced: true})
class BookingDetails extends VuexModule implements IBookingDetailsState {
  
  public loading = false;
  public loadingWorkers = false; 
  public loadingWorker = false; 
  public loadingNotes = true;
  public loadingDialog = false;
  public currentBooking: BookingDto = new BookingDto();
  public selectedBookingRole: BookingRoleDto = new BookingRoleDto();
  public currentBookingRoleWorkers: BookingRoleWorkerDto[] = []
  public offeredWorkersVM: BookingOfferedWorkersViewModel = new BookingOfferedWorkersViewModel();
  public browseWorkersVM: BookingBrowseWorkersViewModel = new BookingBrowseWorkersViewModel();
  public workerSearchViewModel: WorkerSearchViewModel = new WorkerSearchViewModel(null, null, null, true);
  public bookedWorkersVM: BookingBookedWorkersViewModel = new BookingBookedWorkersViewModel();
  public editTimesheetOptions: EditTimesheetOptionsResponse = new EditTimesheetOptionsResponse();
  public editTimesheetMinimumPayRate = -1;
	public model: WorkerProfileDto = null;
  public newBookingOptions: NewBookingOptionsDto = new NewBookingOptionsDto();
  public notes: NoteDto[] = [];
  public noteCategories: NoteCategoryDto[] = [];
  public cancelSuccessful = false;
  public loadingConversations = true;
  public loadingConversation = true;
  public conversations: ConversationDto[] = [];
  public conversation: ConversationDto = new ConversationDto();
  public unsubscribeToConversations: any = null;
  public messages: MessageDto[] = [];
  public unsubscribeToMessages: any = null;
  public conversationParticipants: ConversationParticipantDto[] = [];
  public unsubscribeToConversationParticipants: any = null;
  public agencyUsers: AgencyUserDto[] = [];

  @Action
  public async getAgencyUsers() {
    await ajax.get(`/api/v1/agency/users`)
    .then(response => {
      this.context.commit("setAgencyUsers", response.data );
    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

  @Action
  public async getBooking(booking: BookingDto) {
    this.setLoading(true);
    await ajax.get(`/api/v1/agency/bookings/${booking.id}`)
    .then(response => {
      this.context.commit("setCurrentBooking", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  public async getNewBookingOptions() {
    this.setLoadingDialog(true); 
    await ajax.get(`/api/v1/agency/companies/${BookingDetailsModule.currentBooking.companyId}/new-booking-options`)
    .then(response => {
      this.context.commit("setNewBookingOptions", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  async getNoteCategories() {
    //this.setLoadingNotes(true);
    await ajax.get(`/api/v1/agency/note-categories?entityType=100`)
    .then(response => {
      this.context.commit("setNoteCategories", response.data);
      //this.setLoadingNotes(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      //this.setLoadingNotes(false);
    });
  }

  @Action
  async getNotes() {
    this.setLoadingNotes(true);
    await ajax.get(`/api/v1/agency/bookings/${this.currentBooking.id}/notes`)
    .then(response => {
      this.context.commit("setNotes", response.data);
      this.setLoadingNotes(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingNotes(false);
    });
  }

  @Action
  async createNote(request: CreateNoteRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/bookings/${this.currentBooking.id}/notes`, request)
    .then(response => {
      this.context.commit("setNoteFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editNote(note: NoteDto) {
    const request = new UpdateNoteRequest();
    request.updatedAt = note.updatedAt
    request.description = note.description;
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/bookings/${this.currentBooking.id}/notes/${note.id}`, request)
    .then(response => {
      this.context.commit("setNoteFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action 
  async createBookingDate(request: CreateBookingDateRequest) {
    this.setLoading(true);
    await ajax.post(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/dates`, request)
    .then(response => {
      this.context.commit("setBookingDateFromCreate", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action 
  async cancelBooking(request: CancelBookingRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/cancel`, request)
    .then(response => {
      this.context.commit("setBookingFromCancel", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action 
  async editBookingGeneralDetails(booking: BookingDto) {
    this.setLoadingDialog(true);
    const request: UpdateBookingGeneralDetailsRequest = new UpdateBookingGeneralDetailsRequest();
    request.updatedAt = booking.updatedAt;
    request.ownerId = booking.owner.id;
    request.branchId = booking.branch.id;
    request.isTest = booking.isTest;
    request.testEmailAddresses = booking.testEmailAddresses;
    request.instructions = booking.instructions;
    request.purchaseOrderNumber = booking.purchaseOrderNumber;
    await ajax.put(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/general-details`, request)
    .then(response => {
      this.context.commit("setCurrentBooking", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action 
  async cancelBookingRole(vm: CancelBookingRoleViewModel) {
    this.setLoadingDialog(true);
    const request: CancelBookingRoleRequest = new CancelBookingRoleRequest();
    request.updatedAt = vm.updatedAt;
    request.cancelledReason = vm.cancelledReason;

    await ajax.put(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles/${vm.bookingRoleId}/cancel`, request)
    .then(response => {
      this.context.commit("setBookingRoleFromCancel", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action 
  async cancelShift(vm: CancelShiftViewModel) {
    this.setLoadingDialog(true);
    const request: CancelShiftRequest = new CancelShiftRequest();
    request.updatedAt = vm.updatedAt;
    request.cancelledReason = vm.cancelledReason;
    await ajax.put(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles/${vm.bookingRoleId}/shifts/${vm.shiftId}/cancel`, request)
    .then(response => {
      this.context.commit("setShiftFromCancel", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action 
  async cancelBookingRoleWorkerShift(vm: CancelBookingRoleWorkerShiftViewModel) {
    this.setLoadingDialog(true);
    const request: CancelBookingRoleWorkerShiftRequest = new CancelBookingRoleWorkerShiftRequest();
    request.updatedAt = vm.updatedAt;
    request.cancelledReason = vm.cancelledReason;
    await ajax.put(`/api/v1/agency/booking-role-workers/${BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.id}/shifts/${vm.bookingRoleWorkerShiftId}/cancel`, request)
    .then(response => {
      this.context.commit("setBookingRoleWorkerShiftFromCancel", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getBookingRoleWorkerConfirmationUrl(bookingRoleWorkerId: string) {
    this.setLoadingDialog(true);
    await ajax.get(`/api/v1/agency/booking-role-workers/${bookingRoleWorkerId}/confirmation-url`)
    .then(response => {
      this.context.commit("setConfirmationUrl", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getWorkersForQuickBook() {
    const request = new WorkerProfileSearchRequest();
    request.statuses.push(WorkerStatus.Active);
    request.workTypes.push(WorkType.Temp);
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/workers/search`, request)
    .then(response => {
      this.context.commit("setWorkersForQuickBook", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getWorkerPayRateForQuickBook(request: CalculatePayRateForQuickBookRequest) {
    this.setLoadingDialog(true);
    this.setBrowseSelectedWorkerProfileForQuickBook(request.workerProfile);
    await ajax.get(`/api/v1/agency/workers/${request.workerProfile.id}/temp/pay-rate?positionId=${BookingDetailsModule.selectedBookingRole.positionId}&date=${request.date}`)
    .then(response => {
      this.context.commit("setPayRateForQuickBook", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getWorkerRestrictionSummaryForQuickBook(shiftIds: string[]) {
    const request = new AvailabilityRestrictionCheckRequest();
    request.shiftIds = shiftIds;
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/workers/${BookingDetailsModule.browseWorkersVM.selectedWorkerForQuickBook.id}/temp/availability-restriction-check`, request)
    .then(response => {
      if (response.data === null) {
        response.data = [];
      }
      this.context.commit("setRestrictionSummaryForQuickBook", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getWorkerPayRateForBook(request: CalculatePayRateForBookRequest) {
    this.setLoadingDialog(true);
    await ajax.get(`/api/v1/agency/workers/${request.workerId}/temp/pay-rate?positionId=${BookingDetailsModule.selectedBookingRole.positionId}&date=${request.date}`)
    .then(response => {
      this.context.commit("setPayRateForBook", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getWorkerRestrictionSummaryForBook(shiftIds: string[]) {
    const request = new AvailabilityRestrictionCheckRequest();
    request.shiftIds = shiftIds;
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/workers/${BookingDetailsModule.offeredWorkersVM.selectedWorkerId}/temp/availability-restriction-check`, request)
    .then(response => {
      if (response.data === null) {
        response.data = [];
      }
      this.context.commit("setRestrictionSummaryForBook", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  public async createBookingRole(bookingRoleVM: BookingRoleViewModel) {

    const request = new CreateBookingRoleRequest();
    request.ownerId = bookingRoleVM.owner.id;
    request.contactId = bookingRoleVM.contactLocation.contactId;
    request.positionId = bookingRoleVM.rateCardPosition.positionId;
    request.positionDescription = bookingRoleVM.positionDescription;
    request.chargeRate = bookingRoleVM.chargeRate;
    request.deskId = bookingRoleVM.desk.id;
    request.uniformId = bookingRoleVM.uniform.id;
    request.uniformDescription = bookingRoleVM.uniformDescription
    request.skillIds = bookingRoleVM.skills.map(function(skill) {
      return skill['id'];
    });
    request.qualificationIds = bookingRoleVM.qualifications.map(function(qualification) {
      return qualification['id'];
    });

    //Add the shifts
    for (let index = 0; index < bookingRoleVM.shifts.length; index++) {
      const shiftVM = bookingRoleVM.shifts[index];
      const shiftRequest = new CreateShiftRequest();
      // console.log(`Start At: ${shiftVM.startAtDate}T${shiftVM.endAtTime}`)
      shiftRequest.startAt = new Date(`${shiftVM.startAtDate}T${shiftVM.startAtTime}`)
      const endAt = new Date(`${shiftVM.startAtDate}T${shiftVM.endAtTime}`)
      // console.log(`End At: ${shiftVM.startAtDate}T${shiftVM.endAtTime}`)
      if (shiftRequest.startAt > endAt){
        // console.log(`Start at greater than end at`)
        endAt.setDate(endAt.getDate() +1)
      }
      shiftRequest.endAt = endAt
      // console.log(shiftVM.quantity)
      shiftRequest.quantity = shiftVM.quantity as number;
      shiftRequest.break = shiftVM.break;
      shiftRequest.isPaidBreak = shiftVM.isPaidBreak;
      request.shifts.push(shiftRequest);
    }

    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles`, request)
    .then(response => {
      this.context.commit("setBookingRoleFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async createShift(shiftVM: ShiftViewModel) {

    const request = new CreateShiftRequest();
    request.bookingRoleId = shiftVM.bookingRoleId;
    request.startAt = new Date(`${shiftVM.startAtDate}T${shiftVM.startAtTime}`)
    const endAt = new Date(`${shiftVM.startAtDate}T${shiftVM.endAtTime}`)
    if (request.startAt > endAt){
      endAt.setDate(endAt.getDate() +1)
    }
    request.endAt = endAt
    request.quantity = shiftVM.quantity as number;
    request.break = shiftVM.break;
    request.isPaidBreak = shiftVM.isPaidBreak;
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles/${shiftVM.bookingRoleId}/shifts`, request)
    .then(response => {
      this.context.commit("setShiftFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }


  @Action 
  async deleteBookingDate(bookingDate: BookingDateDto) {
    //this.setLoading(true);
    await ajax.delete(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/dates/${bookingDate.id}`)
    .then(response => {
      this.context.commit("removeBookingDateFromDelete", bookingDate);
      //this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      //this.setLoading(false);
    });
  }

  @Action 
  async deleteShift(shift: ShiftDto) {
    //this.setLoading(true);
    await ajax.delete(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles/${shift.bookingRoleId}/shifts/${shift.id}`)
    .then(response => {
      this.context.commit("removeShiftFromDelete", shift);
      //this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      //this.setLoading(false);
    });
  }

  @Action 
  async deleteBookingRole(bookingRole: BookingRoleDto) {
    //this.setLoading(true);
    await ajax.delete(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles/${bookingRole.id}`)
    .then(response => {
      this.context.commit("removeBookingRoleFromDelete", bookingRole);
      //this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      //this.setLoading(false);
    });
  }


  @Action 
  async deleteBookingRoleWorkerShift(bookingRoleWorkerShift: BookingRoleWorkerShiftDto) {
    //this.setLoading(true);
    await ajax.delete(`/api/v1/agency/booking-role-workers/${BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.id}/shifts/${bookingRoleWorkerShift.id}`)
    .then(response => {
      this.context.commit("removeBookingRoleWorkerShiftFromDelete", bookingRoleWorkerShift);
      //this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      //this.setLoading(false);
    });
  }

  @Action 
  async updateBookingRole(bookingRole: BookingRoleDto) {
    this.setLoadingDialog(true);
    const request = new UpdateBookingRoleRequest();
    request.updatedAt = bookingRole.updatedAt;
    request.ownerId = bookingRole.ownerId;
    request.contactId = bookingRole.contactId;
    request.positionId = bookingRole.positionId;
    request.positionDescription = bookingRole.positionDescription;
    request.chargeRate = bookingRole.chargeRate;
    request.deskId = bookingRole.desk.id;
    request.skillIds = bookingRole.skills.map(function(skill){
      return skill['id'];
    })
    request.qualificationIds = bookingRole.qualifications.map(function(qualification){
      return qualification['id'];
    })
    request.uniformId = bookingRole.uniformId;
    request.uniformDescription = bookingRole.uniformDescription;

    await ajax.post(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles/${bookingRole.id}`, request)
    .then(response => {
      this.context.commit("setBookingRoleFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  // @Action 
  // async updateSelectedBookingRole(bookingRole: BookingRoleDto) {
  //   this.context.commit("setSelectedBookingRole", bookingRole);
  // }

  @Action 
  async resetAdvancedWorkerSearch(){
    this.context.commit("setBrowseSelectedBookingRole", this.selectedBookingRole);
  }

  @Action 
  async updateBrowseSelectedBookingRole(bookingRole: BookingRoleDto) {
    //Set the search criteria
    this.context.commit("setBrowseSelectedBookingRole", bookingRole);
    //Then immediately search workers
    this.setLoadingWorkers(true);
    const request = new WorkerProfileSearchRequest();
    request.statuses.push(WorkerStatus.Active);
    request.workTypes.push(WorkType.Temp);

    //Positions
    request.positionCodes = this.workerSearchViewModel.selectedPositions.map(function(position: PositionDto) {
      return position.code;
    });

    //Skills
    request.skillMatchType = this.workerSearchViewModel.selectedSkillMatchType;
    request.skillCodes = this.workerSearchViewModel.selectedSkills.map(function(skill: SkillDto) {
      return skill.code;
    });
 
    //Qualifications
    request.qualificationMatchType = this.workerSearchViewModel.selectedQualificationMatchType;
    request.qualificationCodes = this.workerSearchViewModel.selectedQualifications.map(function(qualification: QualificationDto) {
      return qualification.code;
    });

    //Default to 20 miles
    request.distance = 20
    //Fetch lat and long
    request.latitude = BookingDetailsModule.currentBooking.location.geometry.lat
    request.longitude = BookingDetailsModule.currentBooking.location.geometry.lng

    //Availability
    const currentRole: BookingRoleDto = this.currentBooking.roles.find((findRole: BookingRoleDto) => findRole.id === this.browseWorkersVM.bookingRoleId);
    const availability: string[] = [];
    const availabilityDateSlots: string[] = [];
    for (let i = 0; i < currentRole.shifts.length; i++) {
      const shift = currentRole.shifts[i];
      const shiftAvailability = DateTimeUtils.toAvailability(shift);
      availability.push(...shiftAvailability);
      availabilityDateSlots.push(...DateTimeUtils.toAvailabilityDateSlots(shift));
    }
    request.availability = availability;
    request.availabilityDateSlots = availabilityDateSlots;

    //Location Restrictions
    request.locationId = BookingDetailsModule.currentBooking.locationId;
    request.isFavouritesOnly = true;
    request.isIncludeBlocked = false;
    
    await ajax.post(`/api/v1/agency/workers/search`, request)
    .then(response => {
      if (response.data == null) {
        response.data = [];
      }
      this.context.commit("setBrowseWorkerProfiles", response.data);
      if (response.data.length < 1){
        this.context.commit("setBrowseWorker", response.data);
      }
      this.setLoadingWorkers(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingWorkers(false);
    });
  }

  @Action 
  async browseAdvancedWorkerSearch() {
    
    this.setLoadingWorkers(true);
    const request = new WorkerProfileSearchRequest();

    //Set this to Active - not currently allowing selection of anything other than active
    request.statuses.push(this.workerSearchViewModel.selectedStatus);

    request.workTypes.push(WorkType.Temp);

    //Branch
    if (this.workerSearchViewModel.selectedBranch != null) {
      request.branchId = this.workerSearchViewModel.selectedBranch.id;
    }

    //Desk
    if (this.workerSearchViewModel.selectedDesk != null) {
      request.deskId = this.workerSearchViewModel.selectedDesk.id;
    }

    //Positions
    request.positionCodes = this.workerSearchViewModel.selectedPositions.map(function(position: PositionDto) {
      return position.code;
    });

    //Skills
    request.skillMatchType = this.workerSearchViewModel.selectedSkillMatchType;
    request.skillCodes = this.workerSearchViewModel.selectedSkills.map(function(skill: SkillDto) {
      return skill.code;
    });
 
    //Qualifications
    request.qualificationCodes = this.workerSearchViewModel.selectedQualifications.map(function(qualification: QualificationDto) {
      return qualification.code;
    });

    //Drivers
    if (this.workerSearchViewModel.driversOnly){
      request.driversOnly = true;
      request.minimumPassengers = this.workerSearchViewModel.selectedMinimumPassengers;
    }

    request.distance = this.workerSearchViewModel.selectedDistance.value
    if (request.distance != 0) {
      //Fetch lat and long
      request.latitude = BookingDetailsModule.currentBooking.location.geometry.lat
      request.longitude = BookingDetailsModule.currentBooking.location.geometry.lng
    }

    //Availability
    const currentRole: BookingRoleDto = this.currentBooking.roles.find((findRole: BookingRoleDto) => findRole.id === this.browseWorkersVM.bookingRoleId);
    const availability: string[] = [];
    const availabilityDateSlots: string[] = [];
    
    // Filter shifts based on selected shift IDs
    const shiftsToCheck = currentRole.shifts.filter(shift => 
      this.workerSearchViewModel.selectedShiftIds.includes(shift.id)
    );
    
    for (let i = 0; i < shiftsToCheck.length; i++) {
      const shift = shiftsToCheck[i];
      if (this.workerSearchViewModel.includeAvailability) {
        const shiftAvailability = DateTimeUtils.toAvailability(shift);
        availability.push(...shiftAvailability);
      }
      availabilityDateSlots.push(...DateTimeUtils.toAvailabilityDateSlots(shift));
    }
    request.availability = availability;
    request.availabilityDateSlots = availabilityDateSlots;
    
    //Location Restrictions
    request.locationId = BookingDetailsModule.currentBooking.locationId;
    request.isFavouritesOnly = this.workerSearchViewModel.isFavouritesOnly;
    request.isIncludeBlocked = this.workerSearchViewModel.isIncludeBlocked;

    await ajax.post(`/api/v1/agency/workers/search`, request)
    .then(response => {
      if (response.data == null) {
        response.data = [];
      }
      this.context.commit("setBrowseWorkerProfiles", response.data);
      if (response.data.length < 1){
        this.context.commit("setBrowseWorker", response.data);
      }
      this.setLoadingWorkers(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingWorkers(false);
    });
  }

  @Action 
  async updateBookedSelectedBookingRole(bookingRole: BookingRoleDto) {
    this.context.commit("setBookedSelectedBookingRole", bookingRole);
    this.setLoadingWorkers(true);
    await ajax.get(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles/${bookingRole.id}/shifts`)
    .then(response => {
      this.context.commit("setShifts", response.data);
      this.setLoadingWorkers(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingWorkers(false);
    });
  }

  @Action 
  async updateOfferedSelectedBookingRole(bookingRole: BookingRoleDto) {
    this.context.commit("setOfferedSelectedBookingRole", bookingRole);
    this.setLoadingWorkers(true);
    await ajax.get(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles/${bookingRole.id}/workers`)
    .then(response => {
      this.context.commit("setOfferedBookingRoleWorkers", response.data);
      this.setLoadingWorkers(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingWorkers(false);
    });
  }

  @Action
  public async updateOfferedSelectedWorker(bookingRoleWorker: BookingRoleWorkerDto){
    this.context.commit("setOfferedSelectedWorker", bookingRoleWorker);
  }

  @Action
  public async updateBookedSelectedShift(shift: ShiftDto){
    this.context.commit("setBookedSelectedShift", shift);
  }

  @Action
  public async updateSelectedBrowseWorker(id: string) {
    const workerProfile = this.browseWorkersVM.workerProfiles.find((findWorker: SelectableEntity<WorkerProfileDto>) => id === findWorker.entity.id);
    if (workerProfile) {
      this.context.commit("setBrowseWorker", workerProfile.entity); 
    } else {
      this.context.commit("setBrowseWorker", null); 
    }
  }

  @Action
  public async addBrowseSelectedWorkerId(workerId: string){
    this.context.commit("setAddBrowseSelectedWorkerId", workerId);
  }

  @Action
  public async removeBrowseSelectedWorkerId(workerId: string){
    this.context.commit("setRemoveBrowseSelectedWorkerId", workerId);
  }

  @Action 
  async createBookingRoleWorkers(request: CreateBookingRoleWorkersRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles/${BookingDetailsModule.browseWorkersVM.bookingRoleId}/workers`, request)
    .then(response => {
      //TODO something here that triggers a success message
      this.context.commit("clearBrowseSelectedWorkerIds"),
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action 
  async createBookingRoleWorkerShifts(request: CreateBookingRoleWorkerShiftsRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/booking-role-workers/${BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.id}/shifts`, request)
    .then(response => {
      //TODO something here that triggers a success message
      //this.context.commit("clearBrowseSelectedWorkerIds"),
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action 
  async quickBook(request: QuickBookRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles/${BookingDetailsModule.browseWorkersVM.bookingRoleId}/quick-book`, request)
    .then(response => {
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action 
  async confirmAppliedBookingRoleWorker(request: ConfirmAppliedBookingRoleWorkerRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles/${this.offeredWorkersVM.selectedBookingRole.id}/workers/${this.offeredWorkersVM.selectedBookingRoleWorker.id}/applied`, request)
    .then(response => {
      //TODO something here that triggers a success message
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action 
  async rejectAppliedBookingRoleWorker(request: RejectAppliedBookingRoleWorkersRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles/${this.offeredWorkersVM.selectedBookingRole.id}/workers/${this.offeredWorkersVM.selectedBookingRoleWorker.id}/rejected`, request)
    .then(response => {
      //TODO something here that triggers a success message
      //this.context.commit("setAppliedBookingRoleWorkersFromRejected", ),
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action 
  async bookAppliedBookingRoleWorker(request: BookAppliedBookingRoleWorkerRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles/${this.offeredWorkersVM.selectedBookingRole.id}/workers/${this.offeredWorkersVM.selectedBookingRoleWorker.id}/booked`, request)
    .then(response => {
      //TODO something here that triggers a success message
      //Also need to update the timesheets list
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getEditTimesheetOptions() {
    this.setLoadingDialog(true);
    await ajax.get(`/api/v1/agency/locations/${this.currentBooking.locationId}/timesheet-options`)
    .then(response => {
      this.context.commit("setEditTimesheetOptions", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getEditTimesheetMinimumPayRate(request: WorkerMinimumPayRateRequest) {
    this.setLoadingDialog(true);
    this.context.commit("setEditTimesheetMinimumPayRate", -1);
    await ajax.get(`/api/v1/agency/workers/${request.workerId}/temp/minimum-pay-rate?date=${request.date}`)
    .then(response => {
      this.context.commit("setEditTimesheetMinimumPayRate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  public async getBrowseWorker(id: string) {
    this.setLoadingWorker(true); 
    await ajax.get(`/api/v1/agency/workers/${id}/profile`)
    .then(response => {
      this.context.commit("setBrowseWorker", response.data);
      this.setLoadingWorker(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingWorker(false);
    })
  }

  @Action
  public async getOfferedWorker(id: string) {
    this.setLoadingWorker(true); 
    await ajax.get(`/api/v1/agency/workers/${id}/profile`)
    .then(response => {
      this.context.commit("setOfferedWorker", response.data);
      this.setLoadingWorker(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingWorker(false);
    })
  }

  @Action
  async getWorkerSearchOptions() {
    this.setLoadingDialog(true);
    await ajax.get(`/api/v1/agency/workers/search-options`)
    .then(response => {
      this.context.commit("setWorkerSearchOptions", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editShift(shiftVM: ShiftViewModel){
    const request = new UpdateShiftRequest();
    request.updatedAt = shiftVM.updatedAt;
    request.startAt = new Date(`${shiftVM.startAtDate}T${shiftVM.startAtTime}`)
    const endAt = new Date(`${shiftVM.startAtDate}T${shiftVM.endAtTime}`)
    // console.log("Values taken from form...");
    // console.log(shiftVM.startAtTime);
    // console.log(request.startAt);
    // console.log(shiftVM.endAtTime);
    // console.log(endAt);
    if (request.startAt > endAt){
      endAt.setDate(endAt.getDate() +1)
    }
    // console.log("Values after manipulation...");
    // console.log(shiftVM.startAtTime);
    // console.log(request.startAt);
    // console.log(shiftVM.endAtTime);
    // console.log(endAt);
    request.endAt = endAt
    request.quantity = shiftVM.quantity as number;
    request.break = shiftVM.break;
    request.isPaidBreak = shiftVM.isPaidBreak;
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/bookings/${BookingDetailsModule.currentBooking.id}/roles/${shiftVM.bookingRoleId}/shifts/${shiftVM.id}`, request)
    .then(response => {
      this.context.commit("setShiftFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editTimesheet(timesheetVM: TimesheetViewModel){
    const request = new UpdateTimesheetRequest();
    request.updatedAt = timesheetVM.updatedAt;
    request.startAt = new Date(`${timesheetVM.startAtDate}T${timesheetVM.startAtTime}`)
    const endAt = new Date(`${timesheetVM.startAtDate}T${timesheetVM.endAtTime}`)
    if (request.startAt > endAt){
      endAt.setDate(endAt.getDate() +1)
    }
    request.endAt = endAt
    request.break = timesheetVM.break;
    request.isPaidBreak = timesheetVM.isPaidBreak;
    request.chargeRate = timesheetVM.chargeRate;
    request.payRate = timesheetVM.payRate;
    request.isJourneyTrackingEnabled = timesheetVM.isJourneyTrackingEnabled;
    request.isSplitPayAndCharge = timesheetVM.isSplitPayAndCharge;
    if (request.isJourneyTrackingEnabled) {
      request.journeyType = timesheetVM.journeyType;
      request.journeyCalculationTypeForPay = timesheetVM.journeyCalculationTypeForPay;
      if (request.journeyCalculationTypeForPay == JourneyCalculationType.Manual) {
        request.travelTimeOneWayForPay = timesheetVM.travelTimeOneWayManualForPay;
        request.distanceOneWayForPay = timesheetVM.distanceOneWayManualForPay;
      } else {
        request.journeyTemplateForPayId = timesheetVM.journeyTemplateForPayId;
      }

      request.journeyCalculationTypeForCharge = timesheetVM.journeyCalculationTypeForCharge;
      if (request.journeyCalculationTypeForCharge == JourneyCalculationType.Manual) {
        request.travelTimeOneWayForCharge = timesheetVM.travelTimeOneWayManualForCharge;
        request.distanceOneWayForCharge = timesheetVM.distanceOneWayManualForCharge;
      } else {
        request.journeyTemplateForChargeId = timesheetVM.journeyTemplateForChargeId;
      }

      request.isDriverExpensePayable = timesheetVM.isDriverExpensePayable;
      request.isDriverExpenseChargeable = timesheetVM.isDriverExpenseChargeable;
      request.isTravelTimePayable = timesheetVM.isTravelTimePayable;
      request.isTravelTimeChargeable = timesheetVM.isTravelTimeChargeable;
    }
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/timesheets/${timesheetVM.id}`, request)
    .then(response => {
      this.context.commit("setTimesheetFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  cleanState() {
    this.context.commit("resetState");
  }

  //Messaging Actions
  @Action
  async createBookingRoleWorkerConversation(request: CreateConversationRequest) {
      //this.setLoading(true);
    await ajax.post(`/api/v1/agency/conversations/booking-role-workers/${BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.id}`, request)
    .then(response => {
      this.context.commit("setBookingRoleWorkerIsConversationCreated", response.data.id);
      //this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      //this.setLoading(false);
    });
  }


  @Action
    async getConversations(pageNumber: number) {

        this.context.commit("clearConversations");
        if (this.selectedBookingRole.desk.conversationTopicId == '') {
          return;
        }
        if (this.selectedBookingRole == null) {
          return;
        }
                
        const q = query(
            collection(db, 
                "tenants/" + AppModule.currentAgencyContext.id + "/conversationTopics/" + BookingDetailsModule.selectedBookingRole.desk.conversationTopicId + '/conversations'), orderBy("status"), where("bookingRoleId", "==", this.selectedBookingRole.id));

        const unsubscribeToConversationsCallback = onSnapshot(q, (querySnapshot: { docChanges: () => any[] }) => {
          querySnapshot.docChanges().forEach((change: { type: string; doc: { id: string; data: () => { (): any; new(): any; branchId: string; deskId: string; conversationTopicId: string; conversationTopicType: number; 
            workerId: string; workerFirebaseUserId: string; workerDisplayName: string; assignedToEntityId: string; assignedToEntityType: number; assignedToFirebaseUserId: string; assignedToDisplayName: string; assignedToAvatar: string; 
            participantFirebaseUserIds: string[]; status: number; subject: string; }; }; }) => {
                if (change.type === "added") {
                    const conversation = new ConversationDto();
                    conversation.id = change.doc.id;
                    conversation.branchId = change.doc.data().branchId;
                    conversation.deskId = change.doc.data().deskId;
                    conversation.workerFirebaseUserId = change.doc.data().workerFirebaseUserId;
                    conversation.workerDisplayName = change.doc.data().workerDisplayName;
                    conversation.workerId = change.doc.data().workerId;
                    conversation.assignedToEntityId = change.doc.data().assignedToEntityId;
                    conversation.assignedToEntityType = change.doc.data().assignedToEntityType;
                    conversation.assignedToFirebaseUserId = change.doc.data().assignedToFirebaseUserId;
                    conversation.assignedToDisplayName = change.doc.data().assignedToDisplayName;
                    conversation.assignedToAvatar = change.doc.data().assignedToAvatar;
                    conversation.participantFirebaseUserIds = change.doc.data().participantFirebaseUserIds;
                    conversation.subject = change.doc.data().subject;
                    conversation.status = change.doc.data().status;
                    conversation.conversationTopicId = change.doc.data().conversationTopicId;
                    conversation.conversationTopicType = change.doc.data().conversationTopicType;
                    this.context.commit("addConversation", conversation);
                }
                if (change.type === "modified") {
                    //Find the conversation and update the values
                    // console.log("Conversation modified event fired");
                    const existingConversationIndex = this.conversations.findIndex((findConversation: ConversationDto) => findConversation.id === change.doc.id);
                    if (existingConversationIndex != -1) {
                        this.conversations[existingConversationIndex].status = change.doc.data().status;
                        this.conversations[existingConversationIndex].assignedToDisplayName = change.doc.data().assignedToDisplayName;
                        this.conversations[existingConversationIndex].assignedToAvatar = change.doc.data().assignedToAvatar;
                        this.conversations[existingConversationIndex].assignedToEntityId = change.doc.data().assignedToEntityId;
                        this.conversations[existingConversationIndex].assignedToEntityType = change.doc.data().assignedToEntityType;
                        this.conversations[existingConversationIndex].participantFirebaseUserIds = change.doc.data().participantFirebaseUserIds;
                    }
                }
                if (change.type === "removed") {
                  const existingConversationIndex = this.conversations.findIndex((findConversation: ConversationDto) => findConversation.id === change.doc.id);
                  if (existingConversationIndex != -1) {
                      // console.log("Removing conversation from store: " + this.conversations[existingConversationIndex].subject);
                      this.context.commit("removeConversation", existingConversationIndex);
                      this.context.commit("clearMessages");
                      this.context.commit("clearConversationParticipants");
                  }
                }
            });
        });
        this.context.commit("setUnsubscribeToConversationsCallback", unsubscribeToConversationsCallback);
        this.setLoadingConversations(false);
    }

    @Action
    public async updateConversation(bookingRoleWorker: BookingRoleWorkerDto){
      const conversation = this.conversations.find((findConvo: ConversationDto) => findConvo.id === bookingRoleWorker.id);
        if (!conversation) {
          this.context.commit("clearMessages");
          this.context.commit("clearConversationParticipants");
          this.context.commit("setConversation", null);
          return;
        }
        this.context.commit("clearMessages");
        this.context.commit("clearConversationParticipants");
        this.context.commit("setConversation", conversation);
        this.setLoadingConversation(true);
        
        const messagesQuery = query(
            collection(db, 
                "tenants/" + AppModule.currentAgencyContext.id + "/conversationTopics/" + conversation.conversationTopicId + "/conversations/" + this.conversation.id + "/conversationMessages"), orderBy("createdAt"));

        //const messagesQuerySnapshot = await getDocs(messagesQuery);
        //var messageResults: MessageDto[] = [];
        //const numberChildren = querySnapshot.size;
        
        //this.setTotalConversationsPages(numberChildren);
        // querySnapshot.forEach(((doc: any) => {
        //     const msg = new MessageDto();
        //     msg.id = doc.id;
        //     msg.body = doc.data().body;
        //     msg.userType = doc.data().userType;
        //     msg.createdAt = doc.data().createdAt.toDate();
        //     msg.createdByDisplayName = doc.data().createdByDisplayName;
        //     results.push(msg);
        // }))

        const unsubscribeToMessagesCallback = onSnapshot(messagesQuery, (querySnapshot: { docChanges: () => any[] }) => {
          querySnapshot.docChanges().forEach((change: { type: string; doc: { id: string; data: () => { (): any; new(): any; createdAt: any; firebaseUserId: string; body: string; hasWorkerRead: boolean} } }) => {
            const msg = new MessageDto();
            msg.id = change.doc.id;
            msg.body = change.doc.data().body;
            msg.firebaseUserId = change.doc.data().firebaseUserId;
            msg.createdAt = change.doc.data().createdAt.toDate();
            msg.hasWorkerRead = change.doc.data().hasWorkerRead;
            if (change.type === "added") {
              this.context.commit("addMessage", msg);
            }
            if (change.type === "modified") {
              this.context.commit("updateMessage", msg);
            }
            if (change.type === "removed") {
              //This isn't possible
            }
          });  
        });
        this.context.commit("setUnsubscribeToMessagesCallback", unsubscribeToMessagesCallback);

        const conversationParticipantsQuery = query(
          collection(db, 
              "tenants/" + AppModule.currentAgencyContext.id + "/conversationTopics/" + conversation.conversationTopicId + "/conversations/" + this.conversation.id + "/conversationParticipants"), orderBy("displayName"));

      //const conversationParticipantsQuerySnapshot = await getDocs(conversationParticipantsQuery);
      //var results: ConversationParticipantDto[] = [];
      //const numberChildren = querySnapshot.size;
      
      //this.setTotalConversationsPages(numberChildren);
      // querySnapshot.forEach(((doc: any) => {
      //     const msg = new MessageDto();
      //     msg.id = doc.id;
      //     msg.body = doc.data().body;
      //     msg.userType = doc.data().userType;
      //     msg.createdAt = doc.data().createdAt.toDate();
      //     msg.createdByDisplayName = doc.data().createdByDisplayName;
      //     results.push(msg);
      // }))

      const unsubscribeToConversationParticipantsCallback = onSnapshot(conversationParticipantsQuery, (querySnapshot: { docChanges: () => any[] }) => {
          querySnapshot.docChanges().forEach((change: { type: string; doc: { id: string; data: () => { (): any; new(): any; displayName: string; entityId: string; avatar: string; entityType: EntityType} } }) => {
              if (change.type === "added") {
                  const conversationParticipant = new ConversationParticipantDto();
                  conversationParticipant.id = change.doc.id;
                  conversationParticipant.avatar = change.doc.data().avatar;
                  conversationParticipant.entityType = change.doc.data().entityType as EntityType;
                  conversationParticipant.entityId = change.doc.data().entityId;
                  conversationParticipant.displayName = change.doc.data().displayName;
                  this.context.commit("addConversationParticipant", conversationParticipant);
              }
              if (change.type === "modified") {
              }
              if (change.type === "removed") { 
              }
          });
          
      });
      this.context.commit("setUnsubscribeToConversationParticipantsCallback", unsubscribeToConversationParticipantsCallback);
      this.setLoadingConversation(false);
    }

    @Action
    public async sendMessage(message: string){
        // const newMessage = new MessageDto();
        // newMessage.createdAt = new Date();
        // newMessage.createdByDisplayName = AppModule.currentUser.displayName;
        // newMessage.createdByFirebaseUserId = AppModule.currentUser.uid;
        // newMessage.createdByEntityType = EntityType.AgencyUser;
        // newMessage.body = message;
        const newMessage = {
            "createdAt": new Date(),
            "tenantId": AppModule.currentAgencyContext.id,
            "firebaseUserId": AppModule.currentUser.uid,
            "hasWorkerRead" : false,
            "type": 1,
            "body": message
        }
        await addDoc(collection(db, "tenants/" + AppModule.currentAgencyContext.id + "/conversationTopics/" + this.conversation.conversationTopicId + "/conversations/" + this.conversation.id + "/conversationMessages"), newMessage);
    }

    @Action
    public async assignConversation(request: AssignConversationRequest) {
      await ajax.put(`/api/v1/agency/conversation-topics/${this.conversation.conversationTopicId}/conversations/${this.conversation.id}/assigned-to`, request)
      .then(response => {

      })
      .catch(error => {
        AppModule.handleApiError(error);
      });
    }

    @Action
    public async editConversationStatus(request: UpdateConversationStatusRequest) {
      await ajax.put(`/api/v1/agency/conversation-topics/${this.conversation.conversationTopicId}/conversations/${this.conversation.id}/status`, request)
      .then(response => {

      })
      .catch(error => {
        AppModule.handleApiError(error);
      });
    }

    @Action
    public async createConversationParticipant(request: CreateConversationParticipantRequest) {
      await ajax.post(`/api/v1/agency/conversation-topics/${this.conversation.conversationTopicId}/conversations/${this.conversation.id}/participants`, request)
      .then(response => {

      })
      .catch(error => {
        AppModule.handleApiError(error);
      });
    }


  @Mutation
  resetState() {

    this.loading = false;
    this.loadingWorkers = false; 
    this.loadingWorker = false;
    this.loadingNotes = true; 
    this.loadingDialog = false;
    this.loadingConversations = true;
    this.loadingConversation = false;
    this.currentBooking = new BookingDto();
    this.selectedBookingRole = null;
    this.currentBookingRoleWorkers = []
    this.browseWorkersVM = new BookingBrowseWorkersViewModel();
    this.offeredWorkersVM = new BookingOfferedWorkersViewModel();
    this.bookedWorkersVM = new BookingBookedWorkersViewModel();
    this.workerSearchViewModel = new WorkerSearchViewModel(null, null, null, true);
    this.newBookingOptions = new NewBookingOptionsDto();
    this.editTimesheetOptions = new EditTimesheetOptionsResponse();
    this.editTimesheetMinimumPayRate = -1;
    this.notes = [];
    this.noteCategories = [];
    this.model = null;
    this.cancelSuccessful = false;
    this.conversation = new ConversationDto();
    this.conversations = [];
    if (this.unsubscribeToConversations) {
        this.unsubscribeToConversations();
        //this.unsubscribeToConversations = null;
    }
    this.messages = [];
    if (this.unsubscribeToMessages) {
        this.unsubscribeToMessages();
        //this.unsubscribeToMessages = null;
    }
    this.conversationParticipants = [];
    if (this.unsubscribeToConversationParticipants) {
      this.unsubscribeToConversationParticipants();
    }
    this.agencyUsers = [];
  }

  @Mutation
  private async setLoading(isLoading: boolean) {
      this.loading = isLoading;
  }

  @Mutation
  private async setLoadingDialog(isLoading: boolean) {
      this.loadingDialog = isLoading;
  } 
  
  @Mutation
  private async setLoadingWorkers(isLoading: boolean) {
      this.loadingWorkers = isLoading;
  } 

  @Mutation
  private async setLoadingWorker(isLoading: boolean) {
      this.loadingWorker = isLoading;
  } 

  @Mutation
  private async setCurrentBooking(booking: BookingDto) {
      this.currentBooking = booking;
      //Also clear the search criteria
      this.browseWorkersVM = new BookingBrowseWorkersViewModel();
  }

  @Mutation
  private async setBookingFromCancel(booking: BookingDto) {
      //Just refreshing the page from the button it came from instead
      this.cancelSuccessful = true;
  }

  @Mutation
  private async setBookingDateFromCreate(bookingDate: BookingDateDto) {
    this.currentBooking.dates.push(bookingDate);
  }

  @Mutation
  private async setConfirmationUrl(url: string) {
    this.offeredWorkersVM.confirmationUrl = url;
  }

  @Mutation
  private async setBookingRoleFromCreate(bookingRole: BookingRoleDto) {
    this.currentBooking.roles.push(bookingRole);
  }

  @Mutation
  private async setBookingRoleFromEdit(bookingRole: BookingRoleDto) {
    const index = this.currentBooking.roles.findIndex((findBookingRole: BookingRoleDto) => bookingRole.id === findBookingRole.id);
    this.currentBooking.roles.splice(index, 1, bookingRole);
    // role.positionDescription = bookingRole.positionDescription;
    // role.positionId = bookingRole.positionId;
    // role.chargeRate = bookingRole.chargeRate;
    // role.qualifications = bookingRole.qualifications;
    // role.owner = bookingRole.owner;
    // role.contact = bookingRole.contact;

    // //UI is not updating properly as these are sub properties - need to investigate why
    // role.owner.person = bookingRole.owner.person;
    // role.contact.person = bookingRole.contact.person;

    // role.shifts = bookingRole.shifts;
    // role.skills = bookingRole.skills;
    // role.deskId = bookingRole.deskId
    // role.desk = bookingRole.desk;
    // role.uniformId = bookingRole.uniformId;
    // role.uniformDescription = bookingRole.uniformDescription;
    // role.uniform = bookingRole.uniform;
    // role.updatedAt = bookingRole.updatedAt;
  }

  @Mutation
  private async setBookingRoleFromCancel(bookingRole: BookingRoleDto) {
    const index = this.currentBooking.roles.findIndex((findBookingRole: BookingRoleDto) => bookingRole.id === findBookingRole.id);
    const role = this.currentBooking.roles[index];
    role.status = bookingRole.status;
    role.updatedAt = bookingRole.updatedAt;
  }

  @Mutation
  private async setOfferedSelectedBookingRole(bookingRole: BookingRoleDto) {
    this.selectedBookingRole = bookingRole;
    this.offeredWorkersVM.selectedBookingRole = bookingRole;
  }

  @Mutation
  private async setBookedSelectedBookingRole(bookingRole: BookingRoleDto) {
    this.bookedWorkersVM.selectedBookingRole = bookingRole;
  }

  // @Mutation
  // private async setAppliedSelectedBookingRole(bookingRole: BookingRoleDto) {
  //   this.bookingRoleWorkersVM.appliedSelectedBookingRole = bookingRole;
  // }

  @Mutation
  private async setOfferedBookingRoleWorkers(bookingRoleWorkers: BookingRoleWorkerDto[]) {
    //Create an empty conversation in each of these to make the responsive in
    //vuejs when one is added
    bookingRoleWorkers.forEach(brw => {
      brw.conversation = new ConversationDto();
    })
    this.offeredWorkersVM.bookingRoleWorkers = bookingRoleWorkers;
    //We also need to update the selected one so that data refreshes as well.
    //TODO: We should really be checking the ID property of the BookingRoleWorker but setting the base entity ID to '' causes wider issues
    if (this.offeredWorkersVM.selectedBookingRoleWorker.workerId != '') {
      const selectedBookingRoleWorker = bookingRoleWorkers.find((findBookingRoleWorker: BookingRoleWorkerDto) => findBookingRoleWorker.id === this.offeredWorkersVM.selectedBookingRoleWorker.id);
      this.offeredWorkersVM.selectedBookingRoleWorker = selectedBookingRoleWorker;
    }    
  }

  @Mutation
  private async setShifts(shifts: ShiftDto[]) {
    this.bookedWorkersVM.shifts = shifts;
    if (this.bookedWorkersVM.shifts && this.bookedWorkersVM.shifts.length > 0) {
      this.bookedWorkersVM.selectedShift = this.bookedWorkersVM.shifts[0];
      this.bookedWorkersVM.timesheets = this.bookedWorkersVM.selectedShift.timesheets;
    }
  }

  @Mutation
  private async setSelectedBookingRole(bookingRole: BookingRoleDto) {
    this.selectedBookingRole = bookingRole;
  }

  @Mutation
  private async setBrowseSelectedBookingRole(bookingRole: BookingRoleDto) {
    this.selectedBookingRole = bookingRole;
    this.browseWorkersVM.selectedWorkerIds = [];
    this.browseWorkersVM = new BookingBrowseWorkersViewModel();
    this.browseWorkersVM.bookingRoleId = this.selectedBookingRole.id;
    //The position we need is the one from the search options as it has the skills/qualification
    // list populated on it
    const position = this.workerSearchViewModel.positions.find((findPosition: PositionDto) => this.selectedBookingRole.position.id === findPosition.id);
    this.workerSearchViewModel.selectedPositions = [position];
    //The list of currently selected skills and qualifications need to 
    //come from the booking role
    this.workerSearchViewModel.selectedSkillMatchType = SearchMatchType.All;
    this.workerSearchViewModel.selectedSkills = this.selectedBookingRole.skills.slice();
    this.workerSearchViewModel.selectedQualificationMatchType = SearchMatchType.All;
    this.workerSearchViewModel.selectedQualifications = this.selectedBookingRole.qualifications.slice();
    this.workerSearchViewModel.selectedBranch = null;
    this.workerSearchViewModel.selectedDesk = null;
    // Initialize with all shifts selected (default behavior)
    this.workerSearchViewModel.selectedShiftIds = this.selectedBookingRole.shifts.map(s => s.id);
  }

  @Mutation
  private async setBrowseWorkerProfiles(workerProfiles: WorkerProfileDto[]) {

    this.browseWorkersVM.workerProfiles =  workerProfiles.map(function(workerProfile) {
        return new SelectableEntity<WorkerProfileDto>(workerProfile);
      });
  }

  @Mutation
  private async setBrowseSelectedWorkerProfile(workerProfile: SelectableEntity<WorkerProfileDto>) {
    this.model = workerProfile.entity;
  }

  @Mutation
  private async setBrowseSelectedWorkerProfileForQuickBook(workerProfile: WorkerProfileDto) {
    this.browseWorkersVM.selectedWorkerForQuickBook = workerProfile;
  }

  // @Mutation
  // private async setBrowseDummySelectedWorkerProfile(workerProfile: SelectableEntity<WorkerProfileDto>) {
  //   this.browseWorkersVM.dummySelectedWorkerProfile = workerProfile;
  // }

  @Mutation
  private async setAddBrowseSelectedWorkerId(workerId: string) {
    this.browseWorkersVM.selectedWorkerIds.push(workerId);
  }

  @Mutation
  private async setRemoveBrowseSelectedWorkerId(workerId: string) {
    const index = this.browseWorkersVM.selectedWorkerIds.indexOf(workerId);
    this.browseWorkersVM.selectedWorkerIds.splice(index, 1); 
  }

  @Mutation
  private async clearBrowseSelectedWorkerIds() {
    //Loop through the VM and remove the workers we just offered to
    this.browseWorkersVM.selectedWorkerIds.forEach(id => {
      const index = this.browseWorkersVM.workerProfiles.findIndex((findWorker: SelectableEntity<WorkerProfileDto>) => findWorker.entity.id === id);
      this.browseWorkersVM.workerProfiles.splice(index, 1);
    });
    //Clear the id list
    this.browseWorkersVM.selectedWorkerIds = [];
  }

  // @Mutation
  // private async setAppliedBookingRoleWorkersFromRejected(bookingRoleWorkers: BookingRoleWorkerDto[]) {
  //   //Loop through the VM and update the workers we just rejected
  //   bookingRoleWorkers.forEach(bookingRoleWorker => {
  //     var index = this.bookingRoleWorkersVM.appliedBookingRoleWorkers.findIndex((findBookingRoleWorker: SelectableEntity<BookingRoleWorkerDto>) => findBookingRoleWorker.entity.id === bookingRoleWorker.id);
  //     this.bookingRoleWorkersVM.appliedBookingRoleWorkers[index].entity = bookingRoleWorker;
  //   });
  //   //Clear the id list
  //   this.bookingRoleWorkersVM.appliedSelectedBookingRoleWorkerIds = [];
  // }

  // @Mutation
  // private async setOfferedSelectedWorker(bookingRoleWorker: BookingRoleWorkerDto) {
  //   this.bookingRoleWorkersVM.offeredSelectedWorker = bookingRoleWorker;
  // }

  @Mutation
  private async setBookedSelectedShift(shift: ShiftDto) {
    this.bookedWorkersVM.timesheets = shift.timesheets;
  }

  @Mutation
  private async setEditTimesheetOptions(editTimesheetOptions: EditTimesheetOptionsResponse) {
    this.editTimesheetOptions = editTimesheetOptions;
  }

  @Mutation
  private async setEditTimesheetMinimumPayRate(minimumPayRate: number) {
    this.editTimesheetMinimumPayRate = minimumPayRate;
  }


  @Mutation
  private async setBrowseWorker(worker: WorkerProfileDto) {
    if (worker) {
      this.browseWorkersVM.selectedWorkerId = worker.id;
      this.browseWorkersVM.selectedWorker = worker;
    } else {
      this.browseWorkersVM.selectedWorkerId = '';
      this.browseWorkersVM.selectedWorker = null;
    }
  }

  @Mutation
  private async setOfferedWorker(worker: WorkerProfileDto) {
    this.offeredWorkersVM.selectedWorker = worker;
    this.offeredWorkersVM.selectedWorkerId = worker.id;
  }

  @Mutation
  private async setWorkerSearchOptions(options: WorkerSearchOptionsResponse) {
    this.workerSearchViewModel = new WorkerSearchViewModel(options.branches, options.positions,  new DistanceViewModel(20, "20"), true);
  }

  @Mutation 
  private async removeBookingDateFromDelete(bookingDate: BookingDateDto) {
    this.currentBooking.dates.splice(this.currentBooking.dates.indexOf(bookingDate), 1);
  }

  @Mutation
  private async setNewBookingOptions(newBookingOptions: NewBookingOptionsDto) {
    this.newBookingOptions = newBookingOptions;
  }

  @Mutation
  private async setWorkersForQuickBook(workers: WorkerProfileDto[]) {
      this.browseWorkersVM.workersForQuickBook = workers;
  }

  @Mutation
  private async setPayRateForQuickBook(payRateResponse: CalculatePayRateResponse) {
      this.browseWorkersVM.payRateForQuickBook = payRateResponse.payRate;
      this.browseWorkersVM.minimumPayRateForQuickBook = payRateResponse.minimumPayRate;
  }

  @Mutation
  private async setRestrictionSummaryForQuickBook(availabilityRestrictionSummaries: AvailabilityRestrictionSummary[]) {
      this.browseWorkersVM.availabilitySummariesForQuickbook = availabilityRestrictionSummaries;
  }

  @Mutation
  private async setPayRateForBook(payRateResponse: CalculatePayRateResponse) {
      this.offeredWorkersVM.payRateForBook = payRateResponse.payRate;
      this.offeredWorkersVM.minimumPayRateForBook = payRateResponse.minimumPayRate;
      this.offeredWorkersVM.availabilitySummariesForBook = [];
  }

  @Mutation
  private async setRestrictionSummaryForBook(availabilityRestrictionSummaries: AvailabilityRestrictionSummary[]) {
      this.offeredWorkersVM.availabilitySummariesForBook = availabilityRestrictionSummaries;
  }

  @Mutation
  private async setShiftFromCreate(shift: ShiftDto) {
    const bookingRole = this.currentBooking.roles.find((findBookingRole: BookingRoleDto) => shift.bookingRoleId === findBookingRole.id);
    bookingRole.shifts.push(shift);
  }

  @Mutation
  private async setShiftFromEdit(shift: ShiftDto) {
    const bookingRoleIndex = this.currentBooking.roles.findIndex((findBookingRole: BookingRoleDto) => shift.bookingRoleId === findBookingRole.id);
    const shiftIndex = this.currentBooking.roles[bookingRoleIndex].shifts.findIndex((findShift: ShiftDto) => shift.id === findShift.id);
    const shiftToUpdate = this.currentBooking.roles[bookingRoleIndex].shifts[shiftIndex];
    shiftToUpdate.isPaidBreak = shift.isPaidBreak;
    shiftToUpdate.break = shift.break;
    shiftToUpdate.quantity = shift.quantity;
    shiftToUpdate.startAt = shift.startAt;
    shiftToUpdate.endAt = shift.endAt;
    shiftToUpdate.updatedAt = shift.updatedAt;
  }

  @Mutation
  private async setShiftFromCancel(shift: ShiftDto) {
    const bookingRoleIndex = this.currentBooking.roles.findIndex((findBookingRole: BookingRoleDto) => shift.bookingRoleId === findBookingRole.id);
    const shiftIndex = this.currentBooking.roles[bookingRoleIndex].shifts.findIndex((findShift: ShiftDto) => shift.id === findShift.id);
    const shiftToUpdate = this.currentBooking.roles[bookingRoleIndex].shifts[shiftIndex];
    shiftToUpdate.status = shift.status;
    shiftToUpdate.updatedAt = shift.updatedAt;
  }

  @Mutation
  private async setBookingRoleWorkerShiftFromCancel(bookingRoleWorkerShift: BookingRoleWorkerShiftDto) {
    //This is too difficult - we rely on a refresh of the whole screen from the calling button
  }

  @Mutation
  private async removeShiftFromDelete(shift: ShiftDto) {
    const bookingRoleIndex = this.currentBooking.roles.findIndex((findBookingRole: BookingRoleDto) => shift.bookingRoleId === findBookingRole.id);
    const shiftIndex = this.currentBooking.roles[bookingRoleIndex].shifts.findIndex((findShift: ShiftDto) => shift.id === findShift.id);
    this.currentBooking.roles[bookingRoleIndex].shifts.splice(shiftIndex, 1);
  }

  @Mutation
  private async setTimesheetFromEdit(timesheet: TimesheetDto) {

    const timesheetToUpdateIndex = this.bookedWorkersVM.timesheets.findIndex((timesheetToFind: TimesheetDto) => timesheetToFind.id == timesheet.id);
    this.bookedWorkersVM.timesheets.splice(timesheetToUpdateIndex, 1, timesheet);    
  }

  @Mutation
  private async removeBookingRoleFromDelete(bookingRole: BookingRoleDto) {
    const bookingRoleIndex = this.currentBooking.roles.findIndex((findBookingRole: BookingRoleDto) => bookingRole.id === findBookingRole.id);
    this.currentBooking.roles.splice(bookingRoleIndex, 1);
  }

  @Mutation
  private async removeBookingRoleWorkerShiftFromDelete(bookingRoleWorkerShift: BookingRoleWorkerShiftDto) {
    const bookingRoleWorkerIndex = this.offeredWorkersVM.bookingRoleWorkers.findIndex((findBookingRoleWorker: BookingRoleWorkerDto) => bookingRoleWorkerShift.bookingRoleWorkerId === findBookingRoleWorker.id);
    const bookingRoleWorkerShiftIndex = this.offeredWorkersVM.bookingRoleWorkers[bookingRoleWorkerIndex].bookingRoleWorkerShifts.findIndex((findBookingRoleWorkerShift: BookingRoleWorkerShiftDto) => bookingRoleWorkerShift.id === findBookingRoleWorkerShift.id);
    this.offeredWorkersVM.bookingRoleWorkers[bookingRoleWorkerIndex].bookingRoleWorkerShifts.splice(bookingRoleWorkerShiftIndex, 1);
  }

  @Mutation
  private async setNoteCategories(noteCategories: NoteCategoryDto[]) {
      this.noteCategories = noteCategories;
  }

  @Mutation
  private async setNotes(notes: NoteDto[]) {
      this.notes = notes;
  }

  @Mutation
  private async setNoteFromCreate(note: NoteDto) {
      this.notes.unshift(note);
  }

  @Mutation
  private async setNoteFromEdit(note: NoteDto) {
      const index = this.notes.findIndex((findNote: NoteDto) => findNote.id === note.id)
      this.notes.splice(index, 1, note);
  }

  @Mutation
  private async setLoadingNotes(isLoading: boolean) {
      this.loadingNotes = isLoading;
  }

  //Messaging mutations
  @Mutation
  private async setLoadingConversations(loading: boolean) {
      this.loadingConversations = loading;
  }

  @Mutation
  private async setLoadingConversation(loading: boolean) {
      this.loadingConversation = loading;
  }

  @Mutation
  private async clearConversations() {
      if (this.unsubscribeToConversations != null) {
          this.unsubscribeToConversations();
          this.unsubscribeToConversations = null;
      }
      this.conversations = [];
      this.conversation = null;
      if (this.unsubscribeToMessages != null) {
          this.unsubscribeToMessages();
          this.unsubscribeToMessages = null;
      }
      this.messages = [];
      if (this.unsubscribeToConversationParticipants != null) {
        this.unsubscribeToConversationParticipants();
      }
      this.conversationParticipants = [];
  }

  @Mutation
  private async addConversation(conversation: ConversationDto) {
      this.conversations.push(conversation);
      //add it to the booking role workers collection
      const bookingRoleWorker = this.offeredWorkersVM.bookingRoleWorkers.find((findBrw: BookingRoleWorkerDto) => conversation.id === findBrw.id);
      if (bookingRoleWorker) {
        bookingRoleWorker.conversation = conversation;
      }
  }

  @Mutation
  private async removeConversation(conversationIndex: number) {
      const conversationByIndex = this.conversations[conversationIndex];
      //remove from the booking role works collection
      const bookingRoleWorker = this.offeredWorkersVM.bookingRoleWorkers.find((findBrw: BookingRoleWorkerDto) => conversationByIndex.id === findBrw.id);
      if (this.conversation.id == conversationByIndex.id) {
        this. conversation = null;
      }
      if (bookingRoleWorker) {
        bookingRoleWorker.conversation = null;
      }
      this.conversations.splice(conversationIndex, 1);
  }

  

  @Mutation
  private async setConversation(conversation: ConversationDto) {
    if (this.unsubscribeToMessages != null) {
      this.unsubscribeToMessages();
    }
    this.messages = [];
    if (this.unsubscribeToConversationParticipants != null) {
        this.unsubscribeToConversationParticipants();
    }
    this.conversationParticipants = [];
    this.conversation = conversation;
  }

  @Mutation
  private async setMessages(messages: MessageDto[]) {
      this.messages = messages;
  }

  @Mutation
  private async addMessage(message: MessageDto) {
      this.messages.push(message);
  }

  @Mutation
  private async updateMessage(message: MessageDto) {
      const foundMessage = this.messages.find((findMessage: MessageDto) => findMessage.id === message.id);
      if (foundMessage != null) {
          foundMessage.hasWorkerRead = message.hasWorkerRead;
      }
  }

  @Mutation
  private async clearMessages() {
      this.messages = [];
      if (this.unsubscribeToMessages != null) {
          this.unsubscribeToMessages();
      }
  }

  @Mutation
  private async setAgencyUsers(agencyUsers: AgencyUserDto[]) {
      this.agencyUsers = agencyUsers;
  }

  @Mutation
  private async setConversationParticipants(conversationParticipants: ConversationParticipantDto[]) {
      this.conversationParticipants = conversationParticipants;
  }

  @Mutation
  private async addConversationParticipant(conversationParticipant: ConversationParticipantDto) {
      this.conversationParticipants.push(conversationParticipant);
  }

  @Mutation
  private async clearConversationParticipants() {
      this.conversationParticipants = [];
      if (this.unsubscribeToConversationParticipants != null) {
          this.unsubscribeToConversationParticipants();
      }
  }

  @Mutation
  private async setBookingRoleWorkerIsConversationCreated(id: string) {
    const brw = this.offeredWorkersVM.bookingRoleWorkers.find((findBrw: BookingRoleWorkerDto) => findBrw.id === id);
    brw.isConversationCreated = true;
  }

  @Mutation
  private async setUnsubscribeToConversationsCallback(callback: any) {
      this.unsubscribeToConversations = callback;
  }

  @Mutation
  private async setUnsubscribeToMessagesCallback(callback: any) {
      this.unsubscribeToMessages = callback;
  }

  @Mutation
  private async setUnsubscribeToConversationParticipantsCallback(callback: any) {
      this.unsubscribeToConversationParticipants = callback;
  }
}

export const BookingDetailsModule = getModule(BookingDetails)
